import { paymentApi as api } from './paymentApi';
export const addTagTypes = ['Payments', 'StripeSubscriptions'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      getPaymentMethods: build.query<
        GetPaymentMethodsApiResponse,
        GetPaymentMethodsApiArg
      >({
        query: () => ({ url: `/payment-methods` }),
        providesTags: ['Payments']
      }),
      getPaymentHistory: build.query<
        GetPaymentHistoryApiResponse,
        GetPaymentHistoryApiArg
      >({
        query: queryArg => ({
          url: `/payment-history`,
          params: { limit: queryArg.limit, offset: queryArg.offset }
        }),
        providesTags: ['Payments']
      }),
      setDefaultPaymentMethod: build.mutation<
        SetDefaultPaymentMethodApiResponse,
        SetDefaultPaymentMethodApiArg
      >({
        query: queryArg => ({
          url: `/payment-methods/set-default`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['Payments']
      }),
      downloadPaymentHistory: build.mutation<
        DownloadPaymentHistoryApiResponse,
        DownloadPaymentHistoryApiArg
      >({
        query: () => ({ url: `/payment-history-download`, method: 'POST' }),
        invalidatesTags: ['Payments']
      }),
      retryFailedPayment: build.mutation<
        RetryFailedPaymentApiResponse,
        RetryFailedPaymentApiArg
      >({
        query: queryArg => ({
          url: `/retry-payment`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['StripeSubscriptions']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type GetPaymentMethodsApiResponse =
  /** status 200 Payment methods found. */ {
    ok?: boolean;
    data?: PaymentMethods;
    message?: string;
  };
export type GetPaymentMethodsApiArg = void;
export type GetPaymentHistoryApiResponse =
  /** status 200 Payment history found. */ {
    ok?: boolean;
    data?: PaymentHistory;
    message?: string;
  };
export type GetPaymentHistoryApiArg = {
  /** number of items to return */
  limit?: number;
  /** offset for pagination (alias for skip) */
  offset?: number;
};
export type SetDefaultPaymentMethodApiResponse =
  /** status 200 Default payment method updated successfully */ {
    ok?: boolean;
    data?: string | null;
    message?: string;
  };
export type SetDefaultPaymentMethodApiArg = {
  /** Payment method ID to set as default */
  body: {
    paymentMethodId?: string;
  };
};
export type RetryFailedPaymentApiResponse =
  /** status 200 Payment retried successfully. */ {
    ok?: boolean;
    data?: {
      success?: boolean;
      status?: string;
    };
    message?: string;
  };
export type RetryFailedPaymentApiArg = {
  /** Optional new payment method to charge */
  body: {};
};
export type PaymentMethods = {
  id: string;
  type: string;
  displayText: string;
  card?: {
    brand: string;
    last4: string;
    funding: string;
  };
  bankAccount?: {
    last4?: string;
    bankName?: string;
    accountType?: string;
  };
  isDefault: boolean;
}[];
export type PaymentHistory = {
  total?: number;
  payments?: {
    id?: string;
    amount?: string;
    paymentMethod?: string;
    invoiceLink?: string;
    planName?: string;
    invoiceId?: string;
    status?: string;
    paymentDate?: string;
  }[];
};
export type DownloadPaymentHistoryApiResponse =
  /** status 200 Payment history found. */ {
    ok?: boolean;
    data?: PaymentHistoryDownload;
    message?: string;
  };
export type DownloadPaymentHistoryApiArg = void;
export type PaymentHistoryDownload = {
  url?: string;
};
export const {
  useGetPaymentMethodsQuery,
  useGetPaymentHistoryQuery,
  useSetDefaultPaymentMethodMutation,
  useDownloadPaymentHistoryMutation,
  useRetryFailedPaymentMutation
} = injectedRtkApi;
